//
// Copyright (c) 2020 Astute Global, Inc.
//

define([
  "marionette",
  "backbone",
  "jquery",
  "messaging/messenger",
  "modules/reportSplit/reports/singleReport/reportUtilities",
  "modules/reportSplit/reports/singleNumberReport/singleNumberReportModule",
], function (Marionette, Backbone, $, Messenger, ReportUtilities, SingleNumberReportModule) {
  "use strict";

  function SingleNumberShow(report, module) {
    const options = report.options;
    const notSpecified = [];

    if (!options.title) {
      notSpecified.push("title");
    }
    if (notSpecified.length) {
      Messenger.okDialog(
        "The following report options are required for single number reports, " +
          "but were not specified:\n" +
          notSpecified.join("\n") +
          "\n\nThey must be added to the report when it is created on the server. " +
          "The report will not be able to display until they are added.",
      );
      return;
    }

    const dataSet = Messenger.reqres.request("singleNumberData", report.href);
    module.listenTo(dataSet, "sync", function () {
      module.showRegion(module.layout);
      Messenger.vent.trigger("report:arrived", report);
      console.log(dataSet);

      let currentTitle = $.t(report.options.title);
      currentTitle = ReportUtilities.figureOutText(currentTitle, true);

      if (report.options.downloadUrlShort) {
        report.downloadID = report.options.downloadUrlShort.substring(1);
        Messenger.reqres.setHandler(
          "downloadUrl:" + report.downloadID,
          function () {
            return ReportUtilities.fetchReportParameters(report.options.downloadUrl);
          },
          this,
        );
      }
      let renderValue = null;
      if (report.href.startsWith("/taskTimeToCompletion")) {
        renderValue = function (value) {
          return Messenger.reqres.request("get:formatted:durationSeconds", value);
        };
      }
      const singleNumberReportModule = new SingleNumberReportModule({
        title: currentTitle,
        field: report.options.field,
        region: module.layout.chart,
        renderValue: renderValue,
      });
      module.addSubModule(singleNumberReportModule);
      singleNumberReportModule.show(dataSet);
    });
  }

  return SingleNumberShow;
});
